"use strict";

const global_var = {
    bp_fullpage: 900
};

export default function (key) {
    return global_var[key];
}